import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MapPin, Phone, Clock, Mail } from 'lucide-react';

const Footer = () => {
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(path);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-b from-pink-900 to-pink-950 text-white">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          
          {/* Logo y Descripción */}
          <div className="col-span-1 md:col-span-2 lg:col-span-1">
            <img 
              src="https://customer-assets.emergentagent.com/job_floral-replica-1/artifacts/unh8rooy_7fa5a7c5-3307-4cdb-82cb-350ffe23ad08-removebg-preview.png"
              alt="TQM Florería"
              className="h-16 md:h-20 w-auto mb-4"
            />
            <p className="text-pink-200 text-sm md:text-base mb-4">
              Flores frescas con entrega en menos de 3 horas. Haz que cada momento sea inolvidable en Arequipa.
            </p>
            <div className="flex gap-4">
              <a
                href="https://www.instagram.com/tqmfloreria.pe"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-pink-800 hover:bg-pink-700 p-3 rounded-full transition-all duration-300 transform hover:scale-110"
                aria-label="Instagram"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
              <a
                href="https://www.facebook.com/tqmflores"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-pink-800 hover:bg-pink-700 p-3 rounded-full transition-all duration-300 transform hover:scale-110"
                aria-label="Facebook"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              <a
                href="https://www.tiktok.com/@tqmfloreria"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-pink-800 hover:bg-pink-700 p-3 rounded-full transition-all duration-300 transform hover:scale-110"
                aria-label="TikTok"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Enlaces Rápidos */}
          <div>
            <h3 className="text-lg md:text-xl font-bold mb-4 text-pink-100">Enlaces Rápidos</h3>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => handleNavigation('/')}
                  className="text-pink-200 hover:text-white transition-colors duration-300 text-sm md:text-base"
                >
                  Inicio
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigation('/nosotros')}
                  className="text-pink-200 hover:text-white transition-colors duration-300 text-sm md:text-base"
                >
                  Nosotros
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigation('/catalogos')}
                  className="text-pink-200 hover:text-white transition-colors duration-300 text-sm md:text-base"
                >
                  Catálogos
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigation('/ocasiones')}
                  className="text-pink-200 hover:text-white transition-colors duration-300 text-sm md:text-base"
                >
                  Ocasiones
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigation('/galeria')}
                  className="text-pink-200 hover:text-white transition-colors duration-300 text-sm md:text-base"
                >
                  Galería
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigation('/contacto')}
                  className="text-pink-200 hover:text-white transition-colors duration-300 text-sm md:text-base"
                >
                  Contacto
                </button>
              </li>
            </ul>
          </div>

          {/* Información de Contacto */}
          <div>
            <h3 className="text-lg md:text-xl font-bold mb-4 text-pink-100">Contacto</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-pink-300 flex-shrink-0 mt-0.5" />
                <div>
                  <a href="tel:+51959389799" className="text-pink-200 hover:text-white transition-colors duration-300 text-sm md:text-base">
                    +51 959 389 799
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-pink-300 flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-pink-200 text-sm md:text-base">
                    93 Av. Lambramani<br />
                    José Luis Bustamante<br />
                    Arequipa, Perú
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="w-5 h-5 text-pink-300 flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-pink-200 text-sm md:text-base">
                    Lun-Sáb: 8AM - 9PM
                  </p>
                </div>
              </li>
            </ul>
          </div>

          {/* Nuestros Servicios */}
          <div>
            <h3 className="text-lg md:text-xl font-bold mb-4 text-pink-100">Nuestros Servicios</h3>
            <ul className="space-y-2 text-sm md:text-base text-pink-200">
              <li className="flex items-start gap-2">
                <span className="text-pink-400 mt-1">✓</span>
                <span>Delivery Express en menos de 3 horas</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-pink-400 mt-1">✓</span>
                <span>Flores frescas garantizadas</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-pink-400 mt-1">✓</span>
                <span>Arreglos personalizados</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-pink-400 mt-1">✓</span>
                <span>Pago con Yape, Plin y tarjetas</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-pink-400 mt-1">✓</span>
                <span>Retiro en tienda disponible</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-pink-800">
        <div className="max-w-7xl mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-pink-200 text-sm text-center md:text-left">
              © {currentYear} TQM Florería. Todos los derechos reservados.
            </p>
            <div className="flex flex-wrap justify-center gap-4 text-sm">
              <a 
                href="https://wa.me/51959389799?text=Hola,%20quiero%20hacer%20un%20pedido"
                target="_blank"
                rel="noopener noreferrer"
                className="text-pink-200 hover:text-white transition-colors duration-300"
              >
                Política de Privacidad
              </a>
              <span className="text-pink-700">|</span>
              <a 
                href="https://wa.me/51959389799?text=Hola,%20quiero%20hacer%20un%20pedido"
                target="_blank"
                rel="noopener noreferrer"
                className="text-pink-200 hover:text-white transition-colors duration-300"
              >
                Términos y Condiciones
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* WhatsApp Button Integration Note */}
      <div className="pb-20 md:pb-6"></div>
    </footer>
  );
};

export default Footer;
